import React, { Component } from 'react';
import intl from 'react-intl-universal';
import { AddEvent } from '../../utils/CustomEvent';
import './index.scss';

class Swiper extends Component {
    constructor (props) {
        super(props);
        this.container = React.createRef();
        this.translateX = 0; // px unit
        this.state = {
            activeIndex: 0
        };
    }

    componentDidMount () {
        AddEvent(this.container.current, {
            'dragging': (e, status) => {
                this.stopAutoPlay();
                if (e.movementX !== undefined) {
                    this.setTransform(e.movementX + '', 'px', false);
                }
                if (status === 'end') {
                    const $container = this.container.current;
                    const childElementCount = this.getSwiperItem().length;
                    const containerWidth = $container.offsetWidth;
                    const maxContainerWidth = (childElementCount - 1) * containerWidth * -1;
                    const translateX = this.translateX;
                    let _translateX = this.closeToInZoom(translateX, containerWidth);
                    if (_translateX >= containerWidth) _translateX = 0;
                    else if (_translateX <= maxContainerWidth) _translateX = maxContainerWidth;
                    this.setTransform(_translateX, 'px', true);
                    this.setState({
                        activeIndex: parseInt(Math.abs(_translateX) / containerWidth)
                    });
                    this.setAutoPlay();
                }
            }
        });
        this.setAutoPlay();
    }

    getSwiperItem = () => {
        const $container = this.container.current;
        return $container.querySelectorAll('.swiper-item');
    }

    setAutoPlay = () => {
        const autoPlay = this.props.autoPlay;
        if (autoPlay === false) return ;
        const childElementCount = this.getSwiperItem().length;
        this.timer = setInterval(() => {
            let index = this.state.activeIndex + 1;
            if (index >= childElementCount) index = 0;
            this.onClickNav(index);
        }, 3000);
    }
    stopAutoPlay = () => {
        clearInterval(this.timer);
    }

    // Set scroll distance
    setTransform = (translateX, unit, animation) => {
        const $container = this.container.current;
        const isIncrease = typeof translateX === 'string';
        const containerWidth = $container.offsetWidth;
        if (unit === '%') {
            translateX = translateX / 100 * containerWidth;
        }
        if (isIncrease) {
            // Adjust numeric delta
            translateX = this.translateX + +translateX;
        }
        this.toggleAnimation(animation, () => {
            $container.style.transform = `translateX(${translateX}px)`;
            this.translateX = translateX;
        });
    }
    toggleAnimation = (toggle, callback) => {
        if (toggle === undefined) {
            callback && callback();
            return ;
        }
        const animationClass = 'swiper-container-transition';
        const $container = this.container.current;
        const hasAnimationClass = $container.classList.contains(animationClass);
        if (toggle) {
            if (hasAnimationClass) {
                callback && callback();
            } else {
                $container.classList.add(animationClass);
                setTimeout(() => {
                    callback && callback();
                }, 10);
            }
        } else {
            if (hasAnimationClass) {
                $container.classList.remove(animationClass);
                setTimeout(() => {
                    callback && callback();
                }, 10);
            } else {
                callback && callback();
            }
        }
    }

    /**
     * Determine which boundary a number is closer to within a range
     * @param {*} num 
     * @param {*} distance 
     * @example 
     * closeToInZoom(85, 50) = 100
     * closeToInZoom(65, 50) = 50
     * closeToInZoom(-5, 50) = 50
     */
    closeToInZoom = (num, distance) => {
        if (num > 0) distance = Math.abs(distance);
        if (num < 0) distance = Math.abs(distance) * -1;
        const y = num % distance;
        const distanceStart = num - y;
        const distanceEnd = distanceStart + distance;
        if (Math.abs(distanceStart - num) < Math.abs(distanceEnd - num)) {
            return distanceStart;
        }
        return distanceEnd;
    }

    onClickNav = (index) => {
        this.setTransform(-100 * index, '%', true);
        this.setState({
            activeIndex: index
        });
    }

    // Enter / Space activates a pagination dot for keyboard users
    onNavKeyDown = (index, e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            this.onClickNav(index);
        }
    }

    render () {
        const { activeIndex } = this.state;
        const ariaCarousel = intl.formatMessage({ id: 'AriaCarousel' });
        return (
            <div className={`swiper ${this.props.className||''}`} style={this.props.style} role="group" aria-label={ariaCarousel}>
                <div className="swiper-nav">
                    {
                        this.props.children.map((item,index)=>(
                            <span key={index} role="button" tabIndex={0} aria-label={intl.formatMessage({ id: 'AriaSlide' }, { index: index + 1 })} aria-current={activeIndex===index} className={activeIndex===index?'active':''} onClick={()=>this.onClickNav(index)} onKeyDown={(e)=>this.onNavKeyDown(index, e)}></span>
                        ))
                    }
                </div>
                <div ref={this.container} className="swiper-container swiper-container-transition">{this.props.children}</div>
            </div>
        )
    }
}
class SwiperItem extends Component {
    constructor (props) {
        super(props);
    }
    
    render () {
        return (
            <div className="swiper-item" style={this.props.style}>{this.props.children}</div>
        )
    }
}

export { Swiper, SwiperItem };